import { Component, input } from '@angular/core';
import { BarInputs, ChartComponent } from '@charts';

@Component({
  selector: 'ui-bar-chart',
  imports: [ChartComponent],
  template: `
    <chart [type]="'bar'" [typeInputs]="barInputs()" />
  `,
})
export class BarChartComponent {
  barInputs = input.required<BarInputs>();
}
